import type { User } from '../auth/types';

/**
 * Minimal tenant-safety check for the orders domain.
 *
 * Asserts that the given user belongs to the expected company.
 * Throws a typed error when the IDs do not match so callers can
 * distinguish a tenant violation from a generic runtime error.
 *
 * Usage:
 *   assertTenantMatch(user, order.company_id);
 */

export class TenantMismatchError extends Error {
  readonly code = 'TENANT_MISMATCH' as const;

  constructor(userCompanyId: string, resourceCompanyId: string) {
    super(
      `Access denied: user belongs to company "${userCompanyId}" ` +
        `but the requested resource belongs to company "${resourceCompanyId}".`,
    );
    this.name = 'TenantMismatchError';
  }
}

export function assertTenantMatch(user: User, companyId: string): void {
  if (user.company_id !== companyId) {
    throw new TenantMismatchError(user.company_id, companyId);
  }
}
